// extracted by mini-css-extract-plugin
export default {"row":"RepliesWrapper_row__oZm14","active":"RepliesWrapper_active__khvw8","button":"RepliesWrapper_button__yU99a","icon":"RepliesWrapper_icon__0RXuf"};